import { render, staticRenderFns } from "./TabelaMigracaoGuias.vue?vue&type=template&id=680f2a20&scoped=true&"
import script from "./TabelaMigracaoGuias.vue?vue&type=script&lang=js&"
export * from "./TabelaMigracaoGuias.vue?vue&type=script&lang=js&"
import style0 from "./TabelaMigracaoGuias.vue?vue&type=style&index=0&id=680f2a20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f2a20",
  null
  
)

export default component.exports